import React from 'react';
import pt from 'prop-types';
import StorefrontEditorPageDropdown from './page-dropdown';
import StorefrontEditorPageEdit from './page-edit';

import './sidebar.scss';

export default class StorefrontEditorSidebar extends React.PureComponent {
  static propTypes = {
    pages: pt.shape({ templates: pt.array, pages: pt.array }),
    page: pt.object,
    focusedField: pt.string,
    editorConfig: pt.object,
    sectionGroups: pt.array,
    easyblocksConfig: pt.object,
    loading: pt.bool,
    onClickAddPage: pt.func.isRequired,
  };

  render() {
    const {
      pages,
      page,
      focusedField,
      editorConfig,
      easyblocksConfig,
      sectionGroups,
      loading,
      onClickAddPage,
    } = this.props;

    return (
      <div className="storefront-editor--sidebar">
        <StorefrontEditorPageDropdown
          pages={pages}
          page={page}
          loading={loading}
          onClickAddPage={onClickAddPage}
        />

        <StorefrontEditorPageEdit
          page={page}
          focusedField={focusedField}
          editorConfig={editorConfig}
          easyblocksConfig={easyblocksConfig}
          sectionGroups={sectionGroups}
          loading={loading}
        />
      </div>
    );
  }
}
